import "./style.css";
import layout from "./layout.html";
import Text from "@blocks/Text";
import CustomImage from "@blocks/Image";
import Credits from "@blocks/Credits";

export default class Block5 {
  static selector = ".block-5";

  constructor(block, attrs) {
    this.block = block;

    this.block.innerHTML = layout;

    this.firstImageNode = this.block.querySelector(
      ".block-5__section--first .image"
    );
    this.firstTextNode = this.block.querySelector(
      ".block-5__section--first .text"
    );
    this.firstCreditsNode = this.block.querySelector(
      ".block-5__section--first .credits"
    );

    this.secondImageNode = this.block.querySelector(
      ".block-5__section--second .image"
    );
    this.secondTextNode = this.block.querySelector(
      ".block-5__section--second .text"
    );
    this.secondCreditsNode = this.block.querySelector(
      ".block-5__section--second .credits"
    );

    this.attributes = attrs;
  }

  setup = async () => {
    return new Promise(async (resolve) => {
      await new CustomImage(
        this.firstImageNode,
        this.attributes.firstSection.image
      ).onReady();
      await new Text(
        this.firstTextNode,
        this.attributes.firstSection.text
      ).onReady();
      await new Credits(
        this.firstCreditsNode,
        this.attributes.firstSection.credits
      ).onReady();

      await new CustomImage(
        this.secondImageNode,
        this.attributes.secondSection.image
      ).onReady();
      await new Text(
        this.secondTextNode,
        this.attributes.secondSection.text
      ).onReady();
      await new Credits(
        this.secondCreditsNode,
        this.attributes.secondSection.credits
      ).onReady();
      resolve();
    });
  };

  onReady = async () => {
    return new Promise(async (resolve) => {
      this.mounted = true;
      await this.setup();
      resolve();
    });
  };
}
